module.exports = __webpack_public_path__ + "static/features-dc729d6c6d9fc80c34dfeb0704af8e6f.png";